import { render, staticRenderFns } from "./DefineColumn.vue?vue&type=template&id=72632fa0&scoped=true"
import script from "./DefineColumn.vue?vue&type=script&lang=js"
export * from "./DefineColumn.vue?vue&type=script&lang=js"
import style0 from "./DefineColumn.vue?vue&type=style&index=0&id=72632fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72632fa0",
  null
  
)

export default component.exports